<template>

  <div class="about">
    <div class="text-container">
      <div class="text-inner">
        <h1>À propos de Kiting Zone</h1>
        <p>
          Chez Kiting Zone, nous mettons à votre disposition depuis 2018 différents produits pour
          la pratique du kitefoil et du wingfoil. Nous pouvons aussi sur demande vous fournir
          du matériel pour le windfoil.
        </p>
        <p>
          Basés au Val-de-Ruz (Neuchâtel), nous avons toujours en stock des planches,
          foils et pièces détachées de la marque <a href="https://sabfoil.com">SABFOIL</a> (anciennement MOSES) et
          pouvons aussi obtenir ces produits sur demande s’ils ne sont pas en stock chez nous.
        </p>
        <p>
          La visserie et les covers pour votre foil sont également disponibles chez nous.
        </p>
        <p>
          Nous testons sur l’eau la majorité des produits que nous vous proposons
          et sommes donc à même de vous offrir des conseils personnalisés.
        </p>
        <p>
          Nous affichons les prix officiels sur notre site,
          n’hésitez toutefois pas à nous contacter pour une offre sur mesure via
           le bouton ci-dessous
          ou directement par e-mail à
          <a href="mailto:info@kitingzone.ch">info@kitingzone.ch</a>.
         </p>
         <p>
          Vous pouvez également nous suivre sur notre compte Instagram <a href="https://www.instagram.com/kiting_zone"> @kiting_zone</a>.
       </p>
       <div class="contact-btn">
         <btn href="mailto:info@kitingzone.ch">
           Contactez-nous
         </btn>
       </div>
     </div>
    </div>
  </div>
</template>

<script>
import btn from './Btn';

export default {
  components: {
    btn,
  },
};
</script>

<style>

.about {
  width: 100%;
}

@media screen and (max-width: 640px) {
  .about h1 {
    max-width: 300px;
  }
}

.about .text-container {
  width: 100%;
  max-width: 832px;
  padding: 4em 0;
  margin: 0 auto;
}

.about .text-inner {
  padding: 0 1em;
}

.contact-btn {
  margin-top: 2em;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue